import styled from 'styled-components';
import colors from '../../../config/colors';

const InputTel = styled.div`

  .intl-tel-input.allow-dropdown.separate-dial-code .selected-flag {
    display: flex !important;
    align-items: center;
    width: 90px;
    background: ${colors.GRAY_EXTRA_LIGHT};
  }

  .intl-tel-input.allow-dropdown.separate-dial-code .selected-dial-code {
    padding-left: 8px !important;
  }

  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-4 input, .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-4 input[type="text"], .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-4 input[type="tel"] {
    height: 50px;
  }

  .intl-tel-input {
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    font-size: 16px;
    border: none;
    border-radius: 3px;
    background: ${colors.GRAY_EXTRA_LIGHT};
    color: ${colors.BLACK};
    font-size: 16px;
    transition: all 200ms ease-in-out;
    text-overflow: ellipsis;
    -webkit-appearance: none;
    margin-bottom: 10px;

    @supports (-webkit-touch-callout: none) {

      @media (max-width: 767px) {
        font-size: 16px;
      }
    }

    .flag-container {
      padding: 0px;
    }

    .form-control {
      background: ${colors.GRAY_EXTRA_LIGHT};
      color: ${colors.BLACK};
      font-size: 16px;
      border: none;
      width: 100%;

      &:focus {
        outline: none;
        text-overflow: ellipsis;
        background-color: ${colors.GRAY_EXTRA_LIGHT};
      }

      &::-webkit-input-placeholder {
        font-size: 16px;
        color: ${colors.GRAY_TEXT_MEDLIGHT};
      }

      &:-ms-input-placeholder {
        font-size: 16px;
        color: ${colors.GRAY_TEXT_MEDLIGHT};
      }

      &::placeholder {
        font-size: 16px;
        color: ${colors.GRAY_TEXT_MEDLIGHT};
      }
    }
  }

  .intl-tel-input .form-control::placeholder {
    background-color: ${colors.GRAY_EXTRA_LIGHT} !important;
  }
`;

export default InputTel;
